// @revopush/react-native-code-push is native. App.js wraps the root as
// `codePush(options)(App)`, so the shim must be a passthrough HOC that returns
// the component unchanged, plus the enum/method surface App.js references.
function codePush() {
  return function (App) {
    return App;
  };
}
codePush.InstallMode = { IMMEDIATE: 0, ON_NEXT_RESTART: 1, ON_NEXT_RESUME: 2 };
codePush.SyncStatus = {
  CHECKING_FOR_UPDATE: 0, DOWNLOADING_PACKAGE: 1, INSTALLING_UPDATE: 2,
  UP_TO_DATE: 3, UPDATE_INSTALLED: 4, UNKNOWN_ERROR: 5,
};
codePush.restartApp = function () {};
codePush.sync = function () {};
module.exports = codePush;
module.exports.default = codePush;
